export default {
      id: "shipment_reports-usage",
      viewBox: "0 0 14 16",
      url: __webpack_public_path__ + "img/icons.svg#shipment_reports",
      toString: function () {
        return this.url;
      }
    }